import styles from "./styles.module.scss"

export const RadioInput = ({
  selectedOption,
  option,
  onClose,
}: {
  selectedOption: string
  option: { id: string; label: string }
  onClose: (id: string) => void
}) => {
  return (
    <div className={styles.sortOption} key={option.id}>
      <input
        type="radio"
        className={styles.radioInput}
        checked={option.id === selectedOption}
        onChange={(e) => {
          onClose(e.target.id)
        }}
        id={option.id}
      />
      <label htmlFor={option.id} className={styles.radioLabel}>
        <span className={styles.customRadio}></span>
        {option.label}
      </label>
    </div>
  )
}
